/**
 * AssetFormModal — wraps the shared FormModal with the Step 2 asset
 * field schema. Drives both "Add asset" and "Edit asset" flows.
 */
import React from 'react';
import FormModal from '../../../../components/ui/FormModal/FormModal';
import { ASSET_FORM_FIELDS, type AssetRecord } from './assetFieldSchema';

const FormModalAny = FormModal as unknown as React.ComponentType<any>;

export interface AssetFormModalProps {
  mode: 'add' | 'edit';
  initialAsset?: AssetRecord | null;
  onSubmit: (values: Record<string, unknown>) => Promise<void>;
  onClose: () => void;
}

export default function AssetFormModal({
  mode,
  initialAsset,
  onSubmit,
  onClose,
}: AssetFormModalProps) {
  const isEdit = mode === 'edit';
  // In edit mode the Asset ID is the record key — locking it
  // prevents an ID change from being treated as an unrelated add.
  const fields = isEdit
    ? ASSET_FORM_FIELDS.map((f) => (f.name === 'asset_id' ? { ...f, disabled: true } : f))
    : ASSET_FORM_FIELDS;

  return (
    <FormModalAny
      title={isEdit ? 'Edit Asset' : 'Add Asset'}
      fields={fields}
      initialValues={initialAsset ?? {}}
      submitLabel={isEdit ? 'Save Changes' : 'Add Asset'}
      submittingLabel={isEdit ? 'Saving…' : 'Adding…'}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth={680}
    />
  );
}
